<template>
  <el-card class="!border-none" :body-style="{ height: '100%' }">
    <div class="w-full h-full">
      <div class="flex items-center h-32px" v-if="operateType">
        <p class="pl-10px border-l-3px text-18px border-color-primary">{{ title }}</p>
      </div>
      <el-page-header v-else :content="title" @back="cancel"></el-page-header>
      <el-form
        class="my-20px h-[calc(100%-128px)] overflow-y-auto overflow-x-hidden"
        :model="formData"
        :rules="formRules"
        ref="formRef"
        label-width="150px"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="标题名称" prop="title">
              <el-input
                size="small"
                maxlength="50"
                placeholder="请输入"
                v-model="formData.title"
                clearable
                :disabled="!operateType"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发布组件">
              <el-input
                size="small"
                maxlength="50"
                v-model="currentNode.name"
                clearable
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="置顶等级" prop="sort">
              <el-select
                size="small"
                v-model="formData.sort"
                :disabled="!operateType"
                class="w-full"
              >
                <el-option
                  v-for="item in topList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" v-if="!isLinkComponent">
            <el-form-item label="点击跳转" prop="jumpType">
              <el-select v-model="formData.jumpType" :disabled="!operateType" class="w-full">
                <el-option label="无跳转" :value="0"></el-option>
                <el-option label="栏目" :value="1"></el-option>
                <el-option label="url地址" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="formData.jumpType === 2 || isLinkComponent">
            <el-form-item
              label="url地址"
              :prop="formData.jumpType === 2 || isLinkComponent ? 'url' : ''"
            >
              <el-input
                size="small"
                maxlength="200"
                placeholder="请输入"
                v-model="formData.url"
                clearable
                :disabled="!operateType"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="formData.jumpType === 1 && !isLinkComponent">
            <el-form-item label="跳转栏目" :prop="formData.jumpType === 1 ? 'jumpColumn' : ''">
              <el-select
                v-model="formData.jumpColumn"
                size="medium"
                placeholder="请选择目录"
                clearable
                ref="fatherNode"
                style="width: 400px;"
                :disabled="!operateType"
              >
                <el-input
                  placeholder="此处输入关键词搜索查询"
                  prefix-icon="el-icon-search"
                  v-model="smallTreeFilter"
                  size="mini"
                  clearable
                ></el-input>
                <el-option
                  hidden
                  key="id"
                  :label="selectName"
                  :value="formData.jumpColumn"
                ></el-option>
                <el-tree
                  v-loading="deviceTreeLoading"
                  ref="smallTreeDom"
                  :data="treeData"
                  empty-text="暂无数据"
                  highlight-current
                  :props="defaultTreeProps"
                  :expand-on-click-node="false"
                  :default-expand-all="false"
                  :filter-node-method="filterTreeNode"
                  @node-click="selectHandler"
                  class="text-14px mt-10px"
                >
                </el-tree>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="formData.jumpType !== 0">
            <el-form-item label="跳转方式" :prop="formData.jumpType !== 0 ? 'skipMode' : ''">
              <el-radio v-model="formData.skipMode" :label="1" :disabled="!operateType"
                >打开新页面</el-radio
              >
              <el-radio v-model="formData.skipMode" :label="2" :disabled="!operateType"
                >页内跳转</el-radio
              >
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否显示" prop="isShow">
              <el-switch v-model="formData.isShow" :disabled="!operateType"> </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="!isLinkComponent">
            <el-form-item label="上传图片" :prop="isLinkComponent ? '' : 'imageFile'">
              <el-upload
                class="w-80px h-80px border-1 border-dashed border-hex-d9d9d9 rounded-6px cursor-pointer relative overflow-hidden flex justify-center items-center avatar-uploader"
                action=""
                :before-upload="getFileContent"
                :http-request="uploadImage"
                :show-file-list="false"
                :disabled="!operateType"
                :accept="accept"
              >
                <i
                  v-if="!formData.imageFile"
                  class="el-icon-plus font-28px text-hex-8c939d w-full text-center"
                ></i>
                <el-image
                  v-else
                  :src="`${fileUrl}${formData.imageFile}`"
                  fit="contain"
                  class="w-full h-full"
                ></el-image>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="text-center pt-20px border-t-1px border-color-default" v-if="operateType">
        <el-button type="primary" size="small" @click="save" :loading="saveLoading">保存</el-button>
        <el-button size="small" @click="cancel">取消</el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
import { FileApi } from '@wiz-api/file-management'
import { ColumApi, ColumnTableApi } from '@wiz-api/workbench'
import { treeToOneArray } from '@/assets/js/Common'
import { informationPublishMap } from '../../../js/config'

const fileApi = new FileApi()
const columApi = new ColumApi()
const columnTableApi = new ColumnTableApi()
const LINKVAL = informationPublishMap.component.hyperlink

const isValidUrl = (str) => {
  const reg = /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b)(:\d{1,5})?(\/[^\s]*)?(\?[^\s]*)?(#[^\s]*)?$/i
  const res = reg.test(str)
  if (res) {
    return true
  }
  return false
}
// 校验url是否有效
const checkUrl = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入url地址'))
  }
  if (isValidUrl(value)) {
    return callback()
  }
  return callback(new Error('请输入有效的url地址'))
}
export default {
  name: 'componentPublishManagementDialog',
  props: {
    operateType: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    detailData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    // 当前点击的树形节点信息
    currentNode: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      imgMaxSiz: 0.5, // 允许图片上传的最大值为0.5M;
      file: '',
      accept: 'jpg,png',
      defaultTreeProps: {
        children: 'child',
        label: 'name',
      },
      treeData: [],
      deviceTreeLoading: false,
      selectName: '',
      smallTreeFilter: '',
      linkVal: LINKVAL,
      formData: {
        title: '', // 标题名称
        sort: '', // 排序
        jumpType: '', // 点击跳转
        url: '', // url地址
        jumpColumn: '', // 跳转栏目
        skipMode: '', // 跳转方式
        imageFile: '', // 图片
        isShow: false, // 是否显示
      },
      imgDisplayUrl: '', // 图片显示的base地址
      formRules: {
        title: [{ required: true, message: '请输入标题名称', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序号', trigger: 'blur' }],
        jumpType: [{ required: true, message: '请选择点击跳转方式', trigger: 'blur' }],
        url: [{ validator: checkUrl, trigger: 'blur' }],
        jumpColumn: [{ required: true, message: '请选择要跳转的栏目', trigger: 'blur' }],
        skipMode: [{ required: true, message: '请选择跳转方式', trigger: 'blur' }],
        imageFile: [{ required: false, message: '请上传图片', trigger: 'blur' }],
      },
      saveLoading: false,
      columnFlattenData: [],
      topList: [
        { label: '不置顶', value: 0 },
        { label: '置顶1', value: 5 },
        { label: '置顶2', value: 4 },
        { label: '置顶3', value: 3 },
        { label: '置顶4', value: 2 },
        { label: '置顶5', value: 1 },
      ],
    }
  },
  computed: {
    isLinkComponent() {
      return this.currentNode.type === this.linkVal
    },
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
  },
  methods: {
    // 是否存在相同的banner类型的组件名称
    async isExistSameBannerComponent(title) {
      const [err, res] = await columnTableApi.binnerColumnTableNameContains({
        id: this.detailData.id,
        title,
        columnId: this.currentNode.id,
      })
      if (!err) {
        return res
      }
      return false
    },
    // 是否存在相同的超链接名称
    async isExistSameHyperlinkComponent(title) {
      const [err, res] = await columnTableApi.linkColumnTableNameContains({
        id: this.detailData.id,
        title,
        columnId: this.currentNode.id,
      })
      if (!err) {
        return res
      }
      return false
    },
    save() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          let err
          let isExist
          const params = {
            body: {
              ...this.formData,
              lastModificationTime: null,
              columnId: this.currentNode.id,
            },
            header: {
              'wiz-sensitive-words': false,
            },
          }
          this.saveLoading = true
          if (this.currentNode.type === this.linkVal) {
            // isExist = await this.isExistSameHyperlinkComponent(this.formData.title)
            // if (!isExist) {
            if (this.detailData && this.detailData.id) {
              ;[err] = await columnTableApi.updateLinkColumnTable(params)
            } else {
              ;[err] = await columnTableApi.addLinkColumnTable(params)
            }
            // } else {
            // this.$message.error('标题名称已存在，请修改')
            this.saveLoading = false
            // return
            // }
          } else {
            // isExist = await this.isExistSameBannerComponent(this.formData.title)
            // if (!isExist) {
            if (this.detailData && this.detailData.id) {
              ;[err] = await columnTableApi.updateBinnerColumnTable(params)
            } else {
              ;[err] = await columnTableApi.addBinnerColumnTable(params)
            }
            // } else {
            // this.$message.error('标题名称已存在，请修改')
            this.saveLoading = false
            // return
            // }
          }
          this.saveLoading = false
          if (!err) {
            this.$message.success('保存成功')
            this.$emit('on-success')
          }
        }
      })
    },
    cancel() {
      this.$emit('close')
    },
    /**
     * @description: 搜索区域树
     * @param {*} value
     * @param {*} data
     * @return {*}
     */
    filterTreeNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    selectHandler(data) {
      this.selectName = data.name
      this.formData.jumpColumn = data.id
      this.smallTreeFilter = ''
      this.$refs.fatherNode.blur()
      this.$refs.formRef.clearValidate('jumpColumn')
    },
    async getTreeData() {
      const [err, res] = await columApi.tree(0)
      if (!err) {
        this.treeData = res
        this.columnFlattenData = treeToOneArray(res, 'child')
      }
    },
    /**
     * 获取图片内容并进行预览
     * @param {*} fileId 文件id
     */
    async getImgContent(fileId) {
      // 获取图片内容
      const [error, result] = await fileApi.getPublicImageBaseString(fileId)
      if (!error) {
        this.imgDisplayUrl = `data:image/png;base64,${result.base64}`
      }
    },
    // 获取上传的内容
    getFileContent(file) {
      if (
        !this.accept.includes(
          file.name
            .split('.')
            .at(-1)
            .toLowerCase()
        )
      ) {
        this.$message.warning(`请上传图片格式文件, ${this.accept}`)
        return false
      }
      // 判断图片大小是否大于限制的最大值
      const isGreatThenMaxsize = file.size / 1024 / 1024 > this.imgMaxSiz
      if (isGreatThenMaxsize) {
        this.$message.error(`文件大小超过限制，最大为${this.imgMaxSiz}M`)
        return false
      }
      this.file = file
      return true
    },
    async uploadImage() {
      const [err, res] = await fileApi.upload({
        files: [this.file],
        authLevel: 2,
      })
      if (!err) {
        const item = (res && res[0]) || {}
        this.formData.imageFile = item.id
        this.$forceUpdate()
      }
    },
  },
  created() {},
  async mounted() {
    await this.getTreeData()
    this.formData = _.cloneDeep(this.detailData)
    this.selectName = _.find(this.columnFlattenData, { id: this.formData.jumpColumn })?.name
    this.$nextTick(() => {
      this.$refs.formRef && this.$refs.formRef.clearValidate() // 清除新增表单验证
      if (this.formData.imageFile) {
        this.$forceUpdate()
      }
    })
  },
  watch: {
    smallTreeFilter(val) {
      this.$refs.smallTreeDom.filter(val)
    },
  },
}
</script>

<style lang="scss" scoped>
.tree-scrollbar-style::-webkit-scrollbar {
  width: 6px;
}
::v-deep {
  .el-select .el-input .el-select__caret {
    line-height: 40px;
  }
  .table-input,
  .table-select {
    .el-input__inner {
      border: none;
      padding: 0;
      background: transparent;
      &:focus,
      &:hover,
      &:active {
        background: transparent;
      }
    }
  }
}
::v-deep .table-select {
  .el-icon-arrow-up {
    line-height: 36px !important;
  }
}
::v-deep .el-upload {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
